function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  className: "a_plan-1",
  d: "M301.91,431.25h-12.2a3.44,3.44,0,0,1-3.43-3.43V413.18a3.44,3.44,0,0,1,3.43-3.43h12.2a3.44,3.44,0,0,1,3.43,3.43v10.48h-2V413.18a1.44,1.44,0,0,0-1.43-1.43h-12.2a1.44,1.44,0,0,0-1.43,1.43v14.63a1.44,1.44,0,0,0,1.43,1.43h12.2Z",
  transform: "translate(-286.28 -409.75)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  fillRule: "evenodd",
  className: "a_plan-2",
  d: "M309.08,422.75,304.74,427l-2.44-2.21-1.34,1.3,3.78,3.51,5.67-5.52Z",
  transform: "translate(-286.28 -409.75)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "#6c6c70",
  className: "a_plan-1",
  x: 4.45,
  y: 4.67,
  width: 10.77,
  height: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  fill: "#6c6c70",
  className: "a_plan-1",
  x: 4.45,
  y: 7.67,
  width: 10.77,
  height: 2
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  fill: "#6c6c70",
  className: "a_plan-1",
  x: 4.45,
  y: 10.67,
  width: 6.77,
  height: 2
});

var SvgPlanOptions = function SvgPlanOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24.14 21.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlanOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plan_options.00bb17ed.svg";
export { ForwardRef as ReactComponent };